import { isCrmHost } from '@/pages/crm/crm-access';
import type {
  CreateAdminUserPayload,
  CreateAdminResponse,
  GetAdminsParams,
  GetAdminsResponse,
  UpdateAdminPayload,
  GetMyAdminProfileResponse,
} from '@gokrew/models/admins';
import api from './client';

export async function createAdmin(
  payload: CreateAdminUserPayload
): Promise<CreateAdminResponse> {
  const { data } = await api.post<CreateAdminResponse>('/admins', payload);

  return data;
}

export async function getAdmins(params: GetAdminsParams) {
  const { data } = await api.get<GetAdminsResponse>('/admins', {
    params,
  });

  return data;
}

export async function updateAdmin(
  id: string,
  payload: UpdateAdminPayload
): Promise<CreateAdminResponse> {
  const { data } = await api.put<CreateAdminResponse>(`/admins/${id}`, payload);

  return data;
}

export async function deactivateAdmin(id: string) {
  const { data } = await api.delete(`/admins/${id}`);

  return data;
}

export async function updateAdminStatus(id: string, status: boolean) {
  const { data } = await api.patch(`/admins/${id}/status`, { status });

  return data;
}

export async function sendAdminInvitation(id: string) {
  const { data } = await api.put(`/admins/${id}/sendInvitation`);

  return data;
}

export async function resetAdminPassword(id: string) {
  const { data } = await api.put(`/admins/${id}/reset-password`);

  return data;
}

export async function getMyAdminProfile(): Promise<GetMyAdminProfileResponse> {
  const { data } = await api.get<GetMyAdminProfileResponse>(
    isCrmHost ? '/admin/crm/profile' : '/admins/profile/me'
  );

  return data;
}

export async function updateMyAdminProfile(
  payload: UpdateAdminPayload
): Promise<GetMyAdminProfileResponse> {
  const { data } = await api.put<GetMyAdminProfileResponse>(
    '/admins/profile/me',
    payload
  );

  return data;
}
